import React from 'react';
import styles from './Footer.m.sass';

import {Link} from 'react-router';

import star from './assets/star.svg';

import visa from './assets/payments/visa.svg';
import mastercard from './assets/payments/mastercard.svg';
import americanExpress from './assets/payments/american-express.svg';
import paypal from './assets/payments/paypal.svg';

import skypeIcon from './assets/contacts/skype.svg';
import envelopeIcon from './assets/contacts/envelope.svg';
import discordIcon from './assets/contacts/discord.svg';

import facebookIcon from './assets/social/facebook.svg';
import instagramIcon from './assets/social/instagram.svg';
import twitterIcon from './assets/social/twitter.svg';
import TrustboxContainer from '../../containers/trustboxContainer/TrustboxContainer';
import Logo from '../logo/Logo';


export default class Footer extends React.PureComponent {
  static currentYear = (new Date()).getFullYear();

  render() {
    const {menu} = this.props;

    return (
      <footer className={styles.footer}>
        <div className={styles.footerTop}>
          <div className="container">
            <div className="row">
              <div className={styles.about}>
                <div className={styles.aboutLogo}>
                  <Logo/>
                </div>
                <div className={styles.rating}>
                  <TrustboxContainer type="micro"/>
                </div>
                <p className={styles.aboutText}>All included here mentioned brand names are registered and property of the respective companies. World of Warcraft tm and Blizzard Entertainment are registered trademarks of Blizzard Entertainment Inc</p>
              </div>

              <div className={styles.links}>
                <div className={styles.linksRow}>
                  <div className={styles.linksCol}>
                    <div className={styles.linksHeader}>Information</div>
                    <div className={styles.linksWrap}>
                      {menu && menu.map(({name, page, code}, idx) => (
                        <Link
                          key={code || idx}
                          className={styles.link}
                          to={`/page/${page.slug}`}
                        >
                          <span className={styles.linkText}>{name}</span>
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div className={`${styles.linksCol} ${styles.linksCol__contacts}`}>
                    <div className={styles.linksHeader}>Contact us</div>
                    <div className={styles.linksWrap}>
                      <a className={styles.link} href="skype:live:boosters4gamers?chat" target="_blank" rel="nofollow">
                        <span className={styles.linkIcon}><img src={skypeIcon} alt=""/></span>
                        <span className={styles.linkText}>Boosters4gamers</span>
                      </a>

                      <a className={styles.link} href="https://discord.gg/WVYyYuT" target="_blank" rel="nofollow">
                        <span className={styles.linkIcon}><img src={discordIcon} alt=""/></span>
                        <span className={styles.linkText}>Join Discord</span>
                      </a>

                      <a className={styles.link} href="mailto:bosters4gamers@gmail.com" rel="nofollow">
                        <span className={styles.linkIcon}><img src={envelopeIcon} alt=""/></span>
                        <span className={styles.linkText}>bosters4gamers@gmail.com</span>
                      </a>
                    </div>
                  </div>

                  {/*TODO: uncomment social links when needed*/}
                  {/*<div className={styles.linksCol}>*/}
                  {/*  <div className={styles.linksHeader}>Social networks</div>*/}
                  {/*  <div className={styles.linksWrap}>*/}
                  {/*    <Link className={styles.link} to="#">*/}
                  {/*      <span className={styles.linkIcon}><img src={facebookIcon} alt=""/></span>*/}
                  {/*      <span className={styles.linkText}>Facebook</span>*/}
                  {/*    </Link>*/}
                  {/*    <Link className={styles.link} to="#">*/}
                  {/*      <span className={styles.linkIcon}><img src={instagramIcon} alt=""/></span>*/}
                  {/*      <span className={styles.linkText}>Instagram</span>*/}
                  {/*    </Link>*/}
                  {/*    <Link className={styles.link} to="#">*/}
                  {/*      <span className={styles.linkIcon}><img src={twitterIcon} alt=""/></span>*/}
                  {/*      <span className={styles.linkText}>Twitter</span>*/}
                  {/*    </Link>*/}
                  {/*  </div>*/}
                  {/*</div>*/}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.copyright}>
          <div className="container">
            <div className={styles.copyrightWrapper}>
              <p className={styles.copyrightText}>Copyright © Primecarry {Footer.currentYear}</p>

              <div className={styles.payments}>
                <img src={visa} className={styles.paymentMethod} alt=""/>
                <img src={mastercard} className={styles.paymentMethod} alt=""/>
                <img src={americanExpress} className={styles.paymentMethod} alt=""/>
                <img src={paypal} className={styles.paymentMethod} alt=""/>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./components/footer/Footer.js